import i18n from "src/i18n/config";
import { ActivityIcon } from "src/ui/shared/Loading";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";
import { Tooltip } from "src/ui/shared/Tooltip";
import { makeStyles } from "tss-react/mui";

import { Typography } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    statusCell: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: theme.spacing(1, 2),
    },
}));

export const StatusCell = (props: { status: "connected" | "disconnected" | "pending" }) => {
    const { classes } = useStyles();

    if (props.status === "pending") {
        return (
            <MinimalTableCell className={classes.statusCell}>
                <Tooltip placement="left" title={i18n.t("sidepanels:devicePanel.tooltip.commandPending")}>
                    <span>
                        <ActivityIcon />
                    </span>
                </Tooltip>
            </MinimalTableCell>
        );
    }

    const label = props.status === "connected" ? i18n.t("common:status.connected") : i18n.t("common:status.saved");

    return (
        <MinimalTableCell className={classes.statusCell}>
            <Typography>{label}</Typography>
        </MinimalTableCell>
    );
};
